module.exports = __webpack_public_path__ + "img/pic_6.44b61426.jpg";